import { SceneBase, ToolsProto, ViewType } from "@ortho-next/nextray-core";
import { WebGLRenderer } from "three";
import { CustomCameraControls } from "../Controls/CustomCameraControls";
import { Tools } from "./Tools";

/**
 * Scene to render. Contains all tools, lights, camera and camera controls.
 */
export class Scene extends SceneBase<Tools> {
	public declare cameraControls: CustomCameraControls;

	constructor(renderer: WebGLRenderer, viewType: ViewType, tools: ToolsProto) {
		super(renderer, viewType, tools, false);
		this.cameraControls = new CustomCameraControls(this.camera, viewType);
	}
}
